import React, { useEffect, useMemo, useState } from "react";
import "../../../src/main.css";
import CopyAction from "./CopyAction";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { getCurrentUserRole } from "modules/utilities/utility";
import ConsultDoctorCanvas from "modules/dashboards/actionables/ConsultDoctorCanvas";
import useAllTicketStore from "./all_tickets/store";
import UpdateTicket from './UpdateTicket';
import { Tag, Typography, Tooltip, Table, Space, Button } from 'antd';
import _ from 'lodash';
import { useSettingsStore } from 'modules/configure_settings/store';
import { FilterOutlined } from '@ant-design/icons';
import moment from 'moment';
import TicketModals from './TicketModals';
import { categories } from './data';

function NewTicketsTable({ data, isLoading, refresh, setRefresh, totalPage, setNewPage, newPage, handleSort }) {
    const { pinCode, getPincodeData } = useSettingsStore();

    useEffect(() => {
        _.size(pinCode) === 0 && getPincodeData;
    }, [])
    const [selectedRow, setSelectedRow] = useState("");
    const [showModal, setShowModal] = useState(false);
    const { setRowChecked } = useAllTicketStore();
    const [selectAllCheck, setSelectAllCheck] = useState(false);
    const [userRole] = useState(getCurrentUserRole());


    const handleSortCreatedDate = () => {
        handleSort('sortByCreatedAt');
    }
    const handleSortUpdatedDate = () => {
        handleSort('sortByUpdatedAt');
    }

    const columns = [
        {
            title: 'Ticket #', dataIndex: 'ticketNumber', key: 1, fixed: 'left', align: 'center',
            render: text => text,
            onCell: (_, rowIndex) => {
                return {
                    onClick: () => {
                        setShowModal(true);
                        setSelectedRow(data[rowIndex])
                    },
                    className: 'cursor-pointer'
                };
            }
        },
        { title: 'Name', dataIndex: 'name', key: 2, fixed: 'left' },
        { title: 'Order Id', dataIndex: 'orderId', key: 5, align: 'center', fixed: 'left' },
        { title: 'Flag', dataIndex: 'flag', key: 3, align: 'center' },
        {
            title: 'Email', dataIndex: 'email', key: 4,
            ellipsis: { showTitle: false, }, render: (email) => <Tooltip title={email}>{email}</Tooltip>
        },
        { title: 'Status', dataIndex: 'status', key: 6, align: 'center' },
        { title: 'Category', width: 200, dataIndex: 'category', key: 7 },
        { title: 'Sub Category', width: 200, dataIndex: 'subcategory', key: 8 },
        { title: 'Cxs Request', dataIndex: 'cxsRequest', key: 9 },
        { title: 'Refund Status', dataIndex: 'refundStatus', key: 10, align: 'center' },
        { title: 'Remarks', width: 250, dataIndex: 'remarks', key: 11 },
        {
            title: 'First Comment', dataIndex: 'firstComment', key: 12,
            ellipsis: { showTitle: false, }, render: (email) => <Tooltip title={email}>{email}</Tooltip>
        },
        {
            title: 'Comment', dataIndex: 'comment', key: 13,
            ellipsis: { showTitle: false, }, render: (comment) => <Tooltip title={comment}>{comment}</Tooltip>
        },
        { title: 'Book Slot	', dataIndex: 'bookSlot', key: 14 },
        // { title: 'Priority', dataIndex: 'priority', key: 15 },
        { title: 'Created By', dataIndex: 'createdBy', key: 15 },
        { title: 'Assignee', dataIndex: 'assignee', key: 16 },
        { title: 'Created Date', width: 175, dataIndex: 'createdAt', key: 17, align: 'center' },
        { title: 'UpdatedAt Date', width: 175, dataIndex: 'updatedAt', key: 18, align: 'center' },
        { title: 'Doctor Call Attempt', width: 150, dataIndex: 'doctorCallAttempt', key: 19, fixed: 'right', align: 'center' },
        { title: 'Doctor Assignemnt Count', width: 190, dataIndex: 'doctorAssignmentCount', key: 20, fixed: 'right', align: 'center' },
        { title: 'Action', dataIndex: 'action', key: 21, fixed: 'right' }
    ]

    const statusTags = {
        Closed: "red",
        Open: "green",
        Pending: "orange",
        Resolved: ''
    }

    const refundStatusTag = {
        Successful: 'success',
        Initiated: 'warning',
        Failed: 'error',
        Unavailable: 'default',
        Available: 'processing'
    }
    const onSelectChange = (newSelectedRowKeys) => {
        setRowChecked(newSelectedRowKeys);
        setSelectAllCheck(newSelectedRowKeys);
    };
    const tableData = useMemo(() => {
        const _data = data?.map((row) => {
            const ticket_number = _.get(row, ['ticketNumber'], '');
            const cxName = _.get(row, ['customer', 'first_name'], '');
            const caseId = _.get(row, 'case_id', '#');
            const flagged = _.get(row, 'flagged', false);
            const doctor_call_attempt = _.get(row, 'doctor_call_attempt', 'N/A');
            const doctor_assignment_count = _.get(row, 'doctor_assignment_count', 'N/A');
            const cxEmail = _.get(row, ['customer', 'email'], '');
            const ticketStatus = _.get(row, 'status', '');
            const refund_status = _.get(row, 'refund_status', 'N/A');
            const description = _.get(row, ['provider_meta', 'description'], 'N/A');
            const descriptionValue = _.get(row, ['provider_meta', 'descriptionValue'], 'N/A');
            const first_comment = _.get(row, ['comments', 0, 'description'], '');
            const cxPhoneNumber = _.get(row, ['customer', 'phone_number'], '');

            const ticketNumber = <Tooltip title={ticket_number}>{ticket_number}</Tooltip>;
            const name = <Tooltip title='Lead Details'><Typography.Link href={`/lead-details/${caseId}`} className='text-capitalize'>{cxName}</Typography.Link></Tooltip>;
            const flag = <Tooltip title={flagged ? 'Flagged' : 'Not Flagged'}><span className={flagged ? 'text-danger' : 'text-secondary'}>&#x2691; </span></Tooltip>;
            const doctorCallAttempt = doctor_call_attempt;
            const doctorAssignmentCount = doctor_assignment_count;
            const email = cxEmail;
            const orderId = _.get(row, ['source_meta', 'order_display_id'], 'N/A');
            const status = <Tag color={statusTags[ticketStatus]} > {ticketStatus}</Tag>
            const category = categories[row.category] || row.category;
            const subcategory = categories[row.sub_category] || row.category;
            const cxsRequest = _.get(row, 'request_type', 'N/A');
            const refundStatus = <Tag Tag color={refundStatusTag[refund_status]} > {refund_status}</Tag>
            const remarks = _.get(row, ['remark'], 'N/A') || 'N/A';
            const comment = <Tooltip title={description}>{descriptionValue ?? 'N/A'}</Tooltip>;
            const firstComment = <Tooltip title={first_comment}>{first_comment}</Tooltip>;
            const bookSlot = <ConsultDoctorCanvas caseId={caseId} name={cxName} email={cxEmail} phone={cxPhoneNumber} slotBooking={"tickets"} />
            const createdBy = _.get(row, ['author', 'first_name'], '');
            const assignee = _.get(row, ['current_assignment', 'first_name'], '');
            const createdAt = moment(_.get(row, 'createdAt', '')).utcOffset('+05:30').format('YYYY-MM-DD HH:mm:ss');
            const updatedAt = moment(_.get(row, 'updatedAt', '')).utcOffset('+05:30').format('YYYY-MM-DD HH:mm:ss')
            const action = <div className='d-flex align-items-center gap-2'>
                <UpdateTicket
                    key={row._id}
                    rowData={row}
                    refresh={refresh}
                    setRefresh={setRefresh}
                />
                <span className="table-icon">
                    <Tooltip title='Ticket Details'><CopyAction id={row?._id} rowData={row} /></Tooltip>
                </span>
            </div>
            return { key: row._id, ticketNumber, name, flag, doctorCallAttempt, doctorAssignmentCount, email, orderId, status, category, subcategory, cxsRequest, refundStatus, remarks, comment, firstComment, bookSlot, createdBy, assignee, createdAt, updatedAt, action };
        })
        return _data;
    }, [data])
    return (
        <div>
            {showModal && <TicketModals selectedColumnData={selectedRow} showModal={showModal} setShowModal={setShowModal} />}
            <div className='d-flex justify-content-end gap-2 mx-2'>
                <Space style={{ marginBottom: 16 }}>
                    <FilterOutlined />
                    <Button loading={isLoading} onClick={handleSortCreatedDate}>Sort By created At</Button>
                    <Button loading={isLoading} onClick={handleSortUpdatedDate}>Sort By updated At</Button>
                </Space>
            </div>
            <Table
                bordered
                rowSelection={(userRole === "admin" || userRole === "super_admin" || userRole === "doctor_admin" || userRole === "medical") ? { selectAllCheck, onChange: onSelectChange } : false}
                pagination={false}
                columns={columns}
                dataSource={tableData}
                scroll={{ x: 3100, y: 400 }}
                size="small"
                loading={isLoading}
            />

            {totalPage ? (
                <PaginationDiv
                    newPage={(page) => { setNewPage(page) }}
                    paginationData={{ pageCount: totalPage || 1, page: newPage }}
                />
            ) : (
                <></>
            )}
        </div>
    );
}

export default NewTicketsTable;